import uroczystosc1 from '../../files/images/photosPage/uroczystosc1.jpg'
import uroczystosc2 from '../../files/images/photosPage/uroczystosc2.jpg'
import uroczystosc3 from '../../files/images/photosPage/uroczystosc3.jpg'
import uroczystosc4 from '../../files/images/photosPage/uroczystosc4.jpg'
import uroczystosc5 from '../../files/images/photosPage/uroczystosc5.jpg'
import uroczystosc6 from '../../files/images/photosPage/uroczystosc6.jpg'
import uroczystosc7 from '../../files/images/photosPage/uroczystosc7.jpg'
import uroczystosc8 from '../../files/images/photosPage/uroczystosc8.jpg'


const imagesSlider6 = [
    { image: uroczystosc1, title: 'Sztandar Polski przy ślubowaniu'}, 
    { image: uroczystosc2, title: 'Burmistrz przy sztandarze'}, 
    { image: uroczystosc3, title: 'Kobieta z kwiatkami przy ratownikach'}, 
    { image: uroczystosc4, title: 'Mężczyzna ze sztandarem'}, 
    { image: uroczystosc5, title: 'Przywieszanie flagi Polski'}, 
    { image: uroczystosc6, title: 'Policjanci przy sztandarze'}, 
    { image: uroczystosc7, title: 'Policjanci ze sztandarem'}, 
    { image: uroczystosc8, title: 'Kobieta przy mikrofonie'}, 
  ];
  
  export default imagesSlider6;